module.exports = __webpack_public_path__ + "static/media/icon_35.d0e37cce.svg";